"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rightArrowSymbol = exports.interpunctSymbol = exports.fieldParams = void 0;

var _react = _interopRequireDefault(require("react"));

var _localization = require("@lt/localization");

var _userflow = require("../../icons-react/userflow");

var fieldParams = {
  days: [{
    name: 'start',
    placeholder: function placeholder(searchType) {
      return _localization.i18n.t('search.title.startDate', {
        context: searchType
      });
    },
    icon: /*#__PURE__*/_react["default"].createElement(_userflow.Plane, {
      width: 24,
      height: 24
    })
  }, {
    name: 'end',
    placeholder: function placeholder(searchType) {
      return _localization.i18n.t('search.title.endDateCapital', {
        context: searchType
      });
    },
    icon: /*#__PURE__*/_react["default"].createElement(_userflow.FlightOut, {
      width: 24,
      height: 24
    })
  }],
  month: [{
    name: 'month',
    placeholder: function placeholder() {
      return _localization.i18n.t('cigarettePreview.datePicker.nightsCount');
    },
    icon: /*#__PURE__*/_react["default"].createElement(_userflow.Calendar, {
      width: 16,
      height: 16
    })
  }, {
    name: 'nightsCount',
    placeholder: function placeholder() {
      return _localization.i18n.t('cigarettePreview.datePicker.nightsCount');
    },
    icon: /*#__PURE__*/_react["default"].createElement(_userflow.Nights, {
      width: 16,
      height: 16
    })
  }]
};
exports.fieldParams = fieldParams;
var rightArrowSymbol = "\u2192";
exports.rightArrowSymbol = rightArrowSymbol;
var interpunctSymbol = "\xB7";
exports.interpunctSymbol = interpunctSymbol;